import { createSlice } from '@reduxjs/toolkit'
import {getWorkshopAppointmentTemplates} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
const initialState= {
    workshopAppointmentTemplates: [],
  loading: "idle",
  error: null }

const workshopAppointmentTemplatesSlice = createSlice({
  name: 'workshopAppointmentTemplates',
  initialState,
  reducers: {
    clearWorkshopAppointmentTemplatesError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getWorkshopAppointmentTemplates.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getWorkshopAppointmentTemplates.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.workshopAppointmentTemplates = action.payload
    },
    [getWorkshopAppointmentTemplates.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearWorkshopAppointmentTemplatesError} = workshopAppointmentTemplatesSlice.actions;
export default workshopAppointmentTemplatesSlice.reducer